import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import get from 'lodash/get';

import { AppRootState } from '../../../store/models/app-state.model';
import { MANDANTS } from '../../../store/utils/files-names';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { AppDto } from '../dtos/app.dto';
import { AppRequestModel } from '../models/app-request.model';
import { AppModel } from '../models/app.model';
import { mapAppRequestModelToAppRequestDto } from '../utils/app-mapping.utils';
import { mapAppDtoToAppModel } from '../utils/mapping.utils';

export const createAppDetail: AsyncThunk<
  AppModel,
  AppRequestModel,
  Record<string, unknown>
> = createAsyncThunk(
  'app/create-app-detail-form',
  async (data: AppRequestModel, api) => {
    const mandantId = get(<AppRootState>api.getState(), `${MANDANTS}`)
      .activeMandantId as number;
    const dataDto = mapAppRequestModelToAppRequestDto(data);
    const url = createPathParams<'mandantId'>(
      Endpoints.BASE_APP_DETAIL_FORM_PATH,
      {
        mandantId,
      }
    );
    const resp: AxiosResponse<AppDto> = await axiosInstance.post(url, dataDto, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return mapAppDtoToAppModel(resp.data);
  }
);
